<template>
    <transition name="floating-buttons-group">
        <div ref="floatingButtonGroup" v-if="modelValue" class="floating-button-group">
            <slot name="buttons" />
        </div>
    </transition>
</template>

<script lang="ts" setup>
interface Props {
    modelValue: boolean
}

const props = withDefaults(defineProps<Props>(), {
    modelValue: false,
})

const emit = defineEmits(['update:modelValue'])
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
@import '@/assets/css/variables.scss';

.floating-button-group {
    background-color: $opteo-white;
    @include container;
    box-shadow: $opteo-shadow-fill-l;
    // TODO: replace with correct shadow variable
    box-shadow:
        0px 32px 32px -16px rgba(0, 0, 0, 0.04),
        0px 16px 16px -8px rgba(0, 0, 0, 0.05),
        0px 8px 8px -4px rgba(0, 0, 0, 0.02),
        0px 4px 4px -2px rgba(0, 0, 0, 0.03),
        0px 2px 2px -1px rgba(0, 0, 0, 0.05),
        0px 1px 1px -0.5px rgba(0, 0, 0, 0.05),
        0px 0px 0px 1px rgba(0, 3, 82, 0.05);
    padding: 1rem 1.375rem;
    touch-action: none;
    overflow: hidden;
    position: fixed;
    left: 50%;
    bottom: 1rem;
    transform: translate3d(-50%, 0rem, 0);
    border-radius: 1.625rem;
    z-index: 9999998;
    display: flex;
    gap: 0.75rem;
}

// Transitions
.floating-buttons-group-enter-active {
    transition: all 0.64s cubic-bezier(0.19, 1, 0.22, 1);
}
.floating-buttons-group-leave-active {
    transition: all 0.48s cubic-bezier(0.19, 1, 0.22, 1);
}
.floating-buttons-group-enter-from,
.floating-buttons-group-leave-to {
    transform: translate3d(-50%, 0.5rem, 0);
    opacity: 0;
}
</style>
